// removed by extract-text-webpack-plugin
module.exports = {"container":"_140zEYKk_DIHK3VEOjOnO6","contentContainer":"Dfbnge5p61KVdmf2Asa2p"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/Main/style/Content.pcss
// module id = 1424
// module chunks = 0